export default "__VITE_ASSET__e890f7f5__"